import RobotDashboardBiddingsList from 'components/organisms/robot_dashboard_biddings_list';
import RobotDashboardSummary from 'components/organisms/robot_dashboard_summary';
import RobotDashboardUsers from 'components/organisms/robot_dashboard_users';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

const RoboDashboard = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = 'Dashboard Robô de Lances - ConLicitação';
  }, []);

  if (!profile.alfa_tester) return <div />;

  return (
    <div className="page-container">
      {pathname === '/robo_dashboard/online' && <RobotDashboardSummary />}
      {pathname === '/robo_dashboard/usuarios' && <RobotDashboardUsers />}
      {pathname === '/robo_dashboard/licitacoes' && <RobotDashboardBiddingsList />}
    </div>
  );
};

export default RoboDashboard;
